"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var srLocaleData = require("i18next-icu/locale-data/sr");
exports.default = srLocaleData;
//# sourceMappingURL=sr.js.map